import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import infiniteScroll from 'vue-infinite-scroll'
import lineClamp from 'vue-line-clamp'
import VueYoutube from 'vue-youtube'

Vue.config.productionTip = false

Vue.use(lineClamp)
Vue.use(infiniteScroll)
Vue.use(VueYoutube)

new Vue({
  router,
  store,
  vuetify,
  directives: { infiniteScroll },
  render: h => h(App)
}).$mount('#app')
